import { Box, Text } from '@cad-arc';
import { BoloQueueView, EventQueueView } from '@mark43/cad-api';
import { PriorityBox } from '../common/components/fr-queues/priority-box';

const PriorityChip = ({ isPriority, label }: { isPriority: boolean; label?: string }) => {
    return (
        <Box
            w={14}
            h="full"
            minH="85px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="base"
            flexShrink={0}
        >
            <PriorityBox isFlashing={isPriority}>
                <Text variant="headingLg">{label}</Text>
            </PriorityBox>
        </Box>
    );
}

export function FrPriorityChip({ data }: { data: EventQueueView }): React.ReactElement {
    if (!data) {
        return <span />;
    }
    return (
        <PriorityChip isPriority={data.isPriority1} label={data.priority} />
    );
}

export function BoloQueuePriorityChip({ data }: { data: BoloQueueView }): React.ReactElement {
    if (!data) {
        return <span />;
    }
    return (
        <PriorityChip isPriority={data.priorityAbbreviation === 'P1'} label={data.priorityAbbreviation} />
    );
}
